var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.body.image.filename)?_c('lazy-picture',{staticClass:"richtext-image",attrs:{"filename":_vm.body.image.filename,"alt":_vm.body.image.alt,"sizes":"(min-width: 600px) 80vw, 100vw","ratioW":16,"ratioH":0}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }